import React from 'react'
import Link from '@/components/Link'

import { Sizes } from '@/ui/Img/image'
import { ProfileImage } from './ProfileImage'

export type Props = {
  group: any
  size?: Sizes
}

export const ProfileImageLink = ({
  group,
  size = 'profile-small',
}: Props): React.ReactElement => {
  return (
    <Link href={group.url} className="profile-image-link">
      <ProfileImage group={group} size={size} />
    </Link>
  )
}

export default ProfileImage
